var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85714 1V2.33333M6 1V2.33333M8.14286 1V2.33333M6.71429 5H3.85714M8.14286 7.66667H3.85714M3.28571 13H8.71429C9.51436 13 9.91443 13 10.22 12.8547C10.4888 12.7269 10.7074 12.5229 10.8443 12.272C11 11.9868 11 11.6134 11 10.8667V3.8C11 3.05327 11 2.67989 10.8443 2.39468C10.7074 2.14379 10.4888 1.93982 10.22 1.81199C9.91443 1.66667 9.51436 1.66667 8.71429 1.66667H3.28571C2.48564 1.66667 2.0856 1.66667 1.78001 1.81199C1.51121 1.93982 1.29266 2.14379 1.15571 2.39468C1 2.67989 1 3.05326 1 3.8V10.8667C1 11.6134 1 11.9868 1.15571 12.272C1.29266 12.5229 1.51121 12.7269 1.78001 12.8547C2.0856 13 2.48564 13 3.28571 13Z",
    stroke: "#7C7C7C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.d2cd13b5bba8777eac38f2d5873e81d5.svg";
export { ForwardRef as ReactComponent };